import { isNull } from 'lodash/fp';
import React, { useMemo } from 'react';

import { useAppSelector } from '../../../hooks/react-redux';
import { useWindowResize } from '../../../hooks/useWindowResize';
import { PageLoadingDots } from '../../shared/loading-dots/PageLoadingDots';
import { TooltipList } from '../../shared/tooltip';
import { ModalDefinition } from './ModalDefinition';
import { ClientDatasetDefinition } from './ClientDatasetDefinition';
import styles from './ClientDatasets.module.scss';
import { ClientDatasetsButtons } from './ClientDatasetsButtons';
import { getAllClientDatasets, getClientDatasetDefinitions, getSelectedDatasetId } from './store';

interface ClientMyDatasetDefinitionsProps {
    title: string;
    datasetId: number;
    isPreview?: boolean
}

export const AllClientDatasetDefinitions: React.FC<ClientMyDatasetDefinitionsProps> = ({ title, datasetId, isPreview = false }) => {
    const myDatasets = useAppSelector(getAllClientDatasets);
    const parentDatasetId = useAppSelector(getSelectedDatasetId);
    const agreementType = useMemo(() => !!parentDatasetId && myDatasets.find(({ datasetId }) => datasetId === parentDatasetId)?.agreementType || '', [myDatasets, parentDatasetId]);
    const documentNames = useMemo(() => !!parentDatasetId && myDatasets.find(({ datasetId }) => datasetId === parentDatasetId)?.documentNames || null, [myDatasets, parentDatasetId]);
    const [, screenHeight] = useWindowResize();
    const definitionHeight = useMemo(() => screenHeight - 240, [screenHeight]);

    const datasetDefinitions = useAppSelector(getClientDatasetDefinitions);
    const parentDefinition = useMemo(() => datasetDefinitions.find(({ datasetId }) => datasetId === parentDatasetId) || null, [datasetDefinitions, parentDatasetId]);

    if (isNull(parentDefinition)) {
        return <PageLoadingDots />;
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.definitionWrapper}>
                <div className={styles.titleWrapper}>
                    <div className={styles.title}>{title}</div>
                    <div className={styles.agreementWrapper}>
                        <div className={styles.agreementLabel}>{agreementType}</div>
                        <TooltipList overlayText={documentNames} placement='right' >
                            <div className={styles.documentNamesIcon}>i</div>
                        </TooltipList>
                    </div>
                </div>
                <div style={{ height: definitionHeight }}>
                    <ClientDatasetDefinition datasetDefinition={parentDefinition!} parents={0} isPreview={isPreview} />
                </div>
                <ClientDatasetsButtons datasetId={datasetId} />
            </div>
            <ModalDefinition isPreview={isPreview} />
        </div>
    );
};
